import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RequirePermission } from '../../features/auth/RequirePermission';
import { DASH_PANELS } from '../../features/dashboard/DashSheet';
import { DashboardPage } from '../../features/dashboard/DashboardPage';

// `panel` opens a detail (ranking, heatmap…) in the side sheet; `member` that person's drawer over it all.
const search = z.object({
  panel: z.enum(DASH_PANELS).optional().catch(undefined),
  member: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/dashboard')({
  validateSearch: search,
  component: function DashboardRoute() {
    const { member, panel } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <RequirePermission permission="team.view">
        <DashboardPage
          memberId={member}
          panel={panel}
          onMemberChange={(id) => {
            // Opening or closing the drawer keeps the page where it is (a row low on the page stays in view).
            void navigate({
              search: (prev) => ({ ...prev, member: id }),
              replace: false,
              resetScroll: false,
            });
          }}
          onPanelChange={(next) => {
            void navigate({ search: { panel: next }, replace: false, resetScroll: false });
          }}
        />
      </RequirePermission>
    );
  },
});
